import getVideoConstraints from '../../../../lib/getVideoConstraints'
import { VideoConstraints } from '../../../../lib/getVideoConstraints/getVideoConstraints'
import get from 'lodash/get'
import { createLocalVideoTrack, LocalVideoTrack } from 'twilio-video'
import { from, Observable, throwError } from 'rxjs'
import { removeVideoTracks } from '../../../actions/tracks/trackActions'
import { v4 as uuidv4 } from 'uuid'
import username from '../../../../lib/username'
import { RoomReducer } from '../../../reducers/room/defaultState'
import browser from '@bt-react/libs/browser'
import { PresenterBackground, VirtualBackgrounds } from '../../../../components/VirtualBackgroundPicker/VirtualBackgroundPicker'
import { applyBackground } from '../../../../lib/virtualBackground'
import { get720FromCustomImage } from '../../../../lib/customVirtualBackground'

/**
 * Creates a local video track
 * @param room - The Twilio Room instance
 * @param deviceId - The device ID to generate the track for
 * @param BTID - The BrightTALK user ID
 * @param background - The background set if there is one
 */
export async function createTrack (room: RoomReducer, deviceId = '', BTID: string, background?: PresenterBackground): Promise<boolean | Error> {

  const dialedInParticipants = room.room ? Array.from(room.room.participants.values()).map(({identity}) => identity).filter((identity) => username.isDialIn(identity)) : []
  const numParticipants: number = (room.room ? 
    Array.from(room.room.participants.values()).filter(({identity}) => username.isPresenter(identity) && !dialedInParticipants.includes(`brightTALK-dialin-${identity}`)).length : 0)
  let constraints: VideoConstraints

  try {
    constraints = await getVideoConstraints(numParticipants, deviceId, background ? background.type !== VirtualBackgrounds.NONE : false)

  }
  catch (e) {

    throw new Error('Failed to get video constraints')

  }

  const idealResolution = get(constraints, 'height.ideal')

  if (!idealResolution) throw new Error('Failed to get ideal resolution')

  const name = `${BTID}-webcam-${idealResolution}-${uuidv4()}`

  const localTrackOptions = { name }
  if (deviceId) localTrackOptions['deviceId'] = deviceId
  const localTrack: LocalVideoTrack = await createLocalVideoTrack({...localTrackOptions, ...constraints })
  if (background && browser.isChrome()) {
    await applyBackground(localTrack, {
      ...background,
      customImage: background.customImage ? get720FromCustomImage(background.customImage) : null
    })
  }

  removeVideoTracks(room.room)

  await room.room?.localParticipant.publishTrack(localTrack)
  return true
}

export default function (room: RoomReducer, deviceId: string, BTID: string | null, background?: PresenterBackground): Observable<boolean | Error> {

  if (!room.room || !BTID) return throwError(new Error('Required data missing'))

  return from(createTrack(room, deviceId, BTID, background))

}
